import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { IoClose } from "react-icons/io5";

const Modal = ({
  title,
  description,
  children,
  isOpen,
  isLoading,
  onClose,
  borderTop,
  size = "sm",
}) => {
  const handleClose = () => {
    return isLoading ? null : onClose();
  };

  const renderClassNames = () => {
    const classes =
      "inline-block w-full text-left align-middle transition-all transform bg-white shadow-xl rounded-lg";

    return `${classes} max-w-${size}`;
  };

  return (
    <>
      <Transition appear as={Fragment} show={isOpen}>
        <Dialog as="div" className="fixed inset-0 z-40" onClose={handleClose}>
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          <div className="min-h-screen max-h-96 overflow-y-auto px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className={renderClassNames()}>
                <div className="flex items-center justify-between py-5 px-6">
                  <div>
                    <div className="text-gray-500">{title}</div>
                    <div className="text-gray-400 text-sm">{description}</div>
                  </div>
                  <div className="cursor-pointer" onClick={handleClose}>
                    <IoClose className="text-gray-500" />
                  </div>
                </div>
                <div className={`border-gray-200 ${borderTop && "border-t"}`}>
                  {children}
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default Modal;
